import React, { useState } from 'react';
import { Text } from '@radix-ui/themes';
import 'tailwindcss/tailwind.css';
import '@radix-ui/themes/styles.css';
import plusSquareIcon from '../../../../assets/images/plussquare.png'; // Adjust path as needed
import maximizeIcon from '../../../../assets/images/maximize.png'; // Adjust path as needed
import micIcon from "../../../../assets/images/mico.png";
import minusIcon from "../../../../assets/images/minus.png";
import roleplayIcon from "../../../../assets/images/roleplay.png";
import MyPeerView from 'components/classroom/components/Peers/MyPeerView';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { User } from 'models/User';

const RpReadyToPresent = ({ showButton, onPress }) => {
  const [isUsersDragableCompOpen, setIsUsersDragableCompOpen] = useState(false);
  const [isExpandedTabel, setIsExpandedTabel] = useState(false);
  const profileData = useSelector((state: RootState) => state?.auth?.user as User);

  return (
    <div className="flex-1 bg-[#212025]">
      <div
        className="bg-[rgba(33,32,37,0.8)] w-[55vw] rounded-lg py-[1vh] px-[4vw] border-[1px] border-[rgba(84,84,85,1)] flex items-center justify-center mt-[-44.5vh] relative left-[12.5vh]"
      >
        <Text
          as="span"
          size="2"
          weight="bold"
          className="text-[rgba(233,190,80,1)]"
        >
          Role Play debrief in progress
        </Text>
        <div className="w-[3vw]" />
        <div className="h-[1.1vh] w-[1.1vh] rounded-full bg-[rgba(67,160,71,1)] border-[1px] border-[rgba(233,190,80,1)]" />
      </div>
      <div className="flex-1">
        <div className="flex justify-center items-center w-[91%] ml-[5%] rounded-[6vw] top-[15%] h-[32vh] bg-white relative">
          <div
            className="bg-[#E9BE50] border-4 border-white rounded-[7.5vh] flex items-center justify-center h-[15vh] w-[15vh] -mt-[4.5vh] shadow-md top-[-20%]"
          >
            <img
              src={roleplayIcon}
              alt="Roleplay"
              className="h-[5vh] w-[5vh] object-contain"
            />
          </div>
          <Text
            as="span"
            size="4"
            weight="bold"
            className="text-black py-[1.5vh] font-[Lato-Regular] text-center w-[60vw] mb-[1vh] -top-[10%]"
          >
            Trainer would like you to volunteer for group presentations
          </Text>
          {showButton && (
            <button
              onClick={onPress}
              className="bg-[#43A047] rounded-[6vw] py-[1.2vh] px-[7vw] mb-[1vh] -top-[5%] shadow-md"
            >
              <Text
                as="span"
                size="4"
                weight="bold"
                className="text-white font-[Lato-Regular]"
              >
                Ready to Present
              </Text>
            </button>
          )}
        </div>
        {!isExpandedTabel && isUsersDragableCompOpen ? (
          <div className="flex items-center bg-[rgba(84,84,85,0.8)] h-[4.5vh] w-[50vw] bottom-[-100px] right-[5vw] z-[999] px-[2vw]">
            <button onClick={() => setIsUsersDragableCompOpen(true)} className="pr-[3vw]">
              <img
                src={plusSquareIcon}
                alt="Plus"
                className="h-[120%] w-[120%] object-contain"
              />
            </button>
            <button onClick={() => setIsUsersDragableCompOpen(true)}>
              <img
                src={maximizeIcon}
                alt="Maximize"
                className="h-[2.5vh] w-[2.5vh] object-contain"
              />
            </button>
            <span className="flex-1" />
            <button onClick={() => {}}>
              <img
                src={micIcon}
                alt="Mic"
                className="h-[90%] w-[90%] object-contain"
              />
            </button>
          </div>
        ) : (
          !isExpandedTabel && (
            <div className="flex flex-col items-center bg-[rgba(84,84,85,0.8)] h-[24.5vh] w-[40vw] z-[999] rounded-[1vh] overflow-hidden bottom-[-13vh] ml-[30vh]">
              <div>
                <MyPeerView
                  style={{ height: '22vh', width: '40vw' }}
                  draggable={false}
                  x={0}
                  y={0}
                />
              </div>
              <div className="flex items-center justify-center h-[3vh] w-[40vw]">
                <Text
                  as="span"
                  size="3"
                  className="text-white w-[33vw] text-center"
                >
                  {profileData?.name}
                </Text>
                <button onClick={() => {}}>
                  <img
                    src={micIcon}
                    alt="Mic"
                    className="h-[60%] w-[60%] object-contain"
                  />
                </button>
              </div>
              <div className="flex items-center justify-between px-[2vw] w-[40vw] mt-[1vh]">
                <button onClick={() => setIsUsersDragableCompOpen(false)}>
                  <img
                    src={minusIcon}
                    alt="Minus"
                    className="h-[110%] w-[110%] object-contain"
                  />
                </button>
                <button onClick={() => setIsUsersDragableCompOpen(false)}>
                  <img
                    src={maximizeIcon}
                    alt="Maximize"
                    className="h-[120%] w-[120%] object-contain"
                  />
                </button>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default RpReadyToPresent;